import Icon from '../components/Icon.vue'

Icon.register({"file":{"width":384,"height":512,"paths":[{"d":"M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file.js
// module id = r24w
// module chunks = 0